import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { LandingComponent } from './pages/landing/landing.component';
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component';
import { ForgetPasswordComponent } from './pages/auth/login/components/forget-password/forget-password.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { OtpCodeComponent } from './pages/auth/login/components/otp-code/otp-code.component';
import { ResetPasswordComponent } from './pages/auth/login/components/reset-password/reset-password.component';
import { ScanCvComponent } from './pages/scan-cv/scan-cv.component';
import { AuthGuard } from './services/auth/auth.guard';
import { ScanResultComponent } from './pages/scan-result/scan-result.component';
import { ContactComponent } from './pages/contact/contact.component';
import { FAQComponent } from './pages/faq/faq.component';
import { GenerateCVStepsComponent } from './pages/generate resume/generate-cv-steps/generate-cv-steps.component';
import { GetStartComponent } from './pages/generate resume/get-start/get-start.component';
import { PolicyPageComponent } from './pages/policy-page/policy-page.component';
import { CareerCoachComponent } from './pages/career-coach/career-coach.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { ScanLinkedinComponent } from './pages/scan-linkedin/scan-linkedin.component';
import { ScanLinkedinResultComponent } from './pages/scan-linkedin-result/scan-linkedin-result.component';
import { ArticalComponent } from './pages/artical/artical.component';
import { ArticalDetailsComponent } from './pages/artical/components/artical-details/artical-details.component';
import { GenerateLinkedinProfileComponent } from './pages/generate-linkedin-profile/generate-linkedin-profile.component';
import { VirtualInterviewComponent } from './pages/virtual-interview/virtual-interview.component';
import { ReviewResumeComponent } from './pages/generate resume/generate-cv-steps/component/review-resume/review-resume.component';
import { paymentRedirectGuard } from './pages/payment/guards/payment-redirect/payment-redirect.guard';
import { CreateCoverLetterComponent } from './pages/create-cover-letter/create-cover-letter.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { PersonaallDataComponent } from './pages/profile/personaall-data/personaall-data.component';
import { GeneratedcvComponent } from './pages/profile/generatedcv/generatedcv.component';
import { ChangepasswordComponent } from './pages/profile/changepassword/changepassword.component';
import { EvaluatedcvsComponent } from './pages/profile/evaluatedcvs/evaluatedcvs.component';
import { GeneratedcoverlettersComponent } from './pages/profile/generatedcoverletters/generatedcoverletters.component';
import { EvaluatedlinkdinComponent } from './pages/profile/evaluatedlinkdin/evaluatedlinkdin.component';
import { VirtualInterviewStepsComponent } from './pages/virtual-interview/virtual-interview-steps/virtual-interview-steps.component';

import { InterviewSessionComponent } from './pages/virtual-interview/components/interview-session/interview-session.component';
import { InterviewResultComponent } from './pages/virtual-interview/components/interview-result/interview-result.component';
import { EvaluatedinterviewComponent } from './pages/profile/evaluatedinterview/evaluatedinterview.component';
import { IntrviewprofileResultComponent } from './pages/profile/evaluatedinterview/intrviewprofile-result/intrviewprofile-result.component';
import { GeneratedlinkdinComponent } from './pages/profile/generatedlinkdin/generatedlinkdin.component';

import { JobVacancyComponent } from './pages/company/company-dashboard/main-page/job-vacancy/job-vacancy.component';
import { AddJobComponent } from './pages/company/company-dashboard/main-page/job-vacancy/add-job/add-job.component';
import { CompanyProfileAdminComponent } from './pages/company/company-dashboard/main-page/company-profile-admin/company-profile-admin.component';
import { CompanyAdminSidebarComponent } from './pages/company/company-dashboard/shared-components/company-admin-sidebar/company-admin-sidebar.component';
import { PositionFormComponent } from './pages/company/company-dashboard/main-page/position/position-form/position-form.component';
import { PositionTableComponent } from './pages/company/company-dashboard/main-page/position/position-table/position-table.component';
import { JoblistComponent } from './components/joblist/joblist.component';

import { AllApplicationsComponent } from './pages/company/company-dashboard/main-page/all-applications/all-applications.component';
import { CompanyReviewsComponent } from './pages/company/company-dashboard/main-page/company-reviews/company-reviews.component';

import { UserProfileComponent } from './pages/company/company-frontend/main-pages/user-profile/user-profile.component';
import { CompanyProfileComponent } from './pages/company/company-frontend/main-pages/company-profile/company-profile.component';
import { JopDescriptionComponent } from './pages/company/company-frontend/main-pages/jobs/jop-description/jop-description.component';
import { ApplyLayoutComponent } from './pages/company/company-frontend/main-pages/jobs/jop-description/apply/apply-layout/apply-layout.component';
import { UesrJobListComponent } from './pages/company/company-frontend/main-pages/jobs/uesr-job-list/uesr-job-list.component';
import { AppliedJobsComponent } from './pages/profile/applied-jobs/applied-jobs.component';
import { AppDetailsComponent } from './pages/company/company-dashboard/main-page/app-details/app-details.component';
import { InterviewSetupComponent } from './pages/company/company-dashboard/main-page/interview-setup/interview-setup.component';
import { SearchComponent } from './pages/search/search.component';
import { CompanyVirtualInterviewComponent } from './pages/company/company-frontend/main-pages/company-virtual-interview/company-virtual-interview.component';
import { StartInterviewComponent } from './pages/company/company-frontend/main-pages/company-virtual-interview/components/start-interview/start-interview.component';
import { VrInterviewResultComponent } from './pages/company/company-dashboard/main-page/interview/vr-interview-result/vr-interview-result.component';
import { ProfileOverviewComponent } from './pages/profile/profile-overview/profile-overview.component';
import { StartSessionComponent } from './pages/company/company-frontend/main-pages/company-virtual-interview/components/start-session/start-session.component';
import { VirtualInterviewsComponent } from './pages/company/company-dashboard/main-page/virtual-interviews/virtual-interviews.component';
import { InterviewResultsComponent } from './pages/company/company-dashboard/main-page/interview-results/interview-results.component';
import { CompanyHomeComponent } from './pages/company/company-home/company-home.component';
import { JobPostHomeComponent } from './pages/company/job-post-home/job-post-home.component';
import { BillingPaymentsComponent } from './pages/company/company-dashboard/main-page/billing-payments/billing-payments.component';
import { BillingServiceDetailsComponent } from './pages/company/company-dashboard/main-page/billing-service-details/billing-service-details.component';
import { BillingJobPostingDetailsComponent } from './pages/company/company-dashboard/main-page/billing-job-posting-details/billing-job-posting-details.component';
import { BillingTalentPurchaseComponent } from './pages/company/company-dashboard/main-page/billing-talent-purchase/billing-talent-purchase.component';
import { BillingVirtualPurchaseComponent } from './pages/company/company-dashboard/main-page/billing-virtual-purchase/billing-virtual-purchase.component';

import { VrMainComponent } from './pages/company/company-dashboard/main-page/vr-main/vr-main.component';
import { VirtualBillingComingSoonComponent } from './pages/company/company-dashboard/main-page/virtual-billing-coming-soon/virtual-billing-coming-soon.component';

const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'search', component: SearchComponent },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'scan-cv', component: ScanCvComponent },
  { path: 'scan-cv-result', component: ScanResultComponent },
  { path: 'scan-linkedin', component: ScanLinkedinComponent },
  { path: 'scan-linkedin-result', component: ScanLinkedinResultComponent },
  {
    path: 'create-linkedin-profile',
    component: GenerateLinkedinProfileComponent,
  },
  { path: 'create-cover-letter', component: CreateCoverLetterComponent },
  { path: 'sign-up', component: SignUpComponent },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'verify-otp', component: OtpCodeComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'generatResume', component: GetStartComponent },
  { path: 'generatResumeSteps', component: GenerateCVStepsComponent },
  { path: 'virtualInterviewSteps', component: VirtualInterviewStepsComponent },
  { path: 'payment', component: PaymentComponent },
  {
    path: 'payment-redirect',
    canActivate: [paymentRedirectGuard],
    redirectTo: '',
  },
  { path: 'home', component: HomeComponent },
  { path: 'company-home', component: CompanyHomeComponent },
  { path: 'job-post', component: JobPostHomeComponent },
  { path: 'articles', component: ArticalComponent },
  { path: 'articleDetails/:id', component: ArticalDetailsComponent },
  { path: 'careerCoach', component: CareerCoachComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'policy', component: PolicyPageComponent },
  { path: 'FQA', component: FAQComponent },
  { path: 'soon', component: ComingSoonComponent },
  { path: 'virtual-interview', component: VirtualInterviewComponent },
  {
    path: 'virtual-interview-session',
    component: InterviewSessionComponent,
  },
  {
    path: 'virtual-interview-result',
    component: InterviewResultComponent,
  },
  { path: 'cv-review', component: ReviewResumeComponent },
  {
    path: 'profile',
    component: ProfileComponent,
    children: [
      { path: 'personal-data', component: PersonaallDataComponent },
      // { path: 'auto-apply-jobs', component: AutoApplyJobsComponent },
      { path: 'generated-cv', component: GeneratedcvComponent },
      // { path: 'interview-training', component: InterviewTrainingComponent },
      { path: 'change-password', component: ChangepasswordComponent },
      { path: 'applied-jobs', component: AppliedJobsComponent },
      { path: 'evaluated-cvs', component: EvaluatedcvsComponent },
      {
        path: 'generated-cover-letters',
        component: GeneratedcoverlettersComponent,
      },
      {
        path: 'enhanced-linkedin-profiles',
        component: GeneratedlinkdinComponent,
      },
      {
        path: 'evaluated-linkdin-profiles',
        component: EvaluatedlinkdinComponent,
      },
      {
        path: 'interview-training',
        component: EvaluatedinterviewComponent,
      },
      {
        path: 'evaluated-interview-profiles',
        component: InterviewResultComponent,
      },
      {
        path: 'profile-overview',
        component: ProfileOverviewComponent,
      },

      { path: '', redirectTo: 'personal-data', pathMatch: 'full' },
    ],
  },
  /** Company Routing http://localhost:4300/company-profile **/
  {
    path: 'company-profile/:id',
    component: CompanyProfileComponent,
  },
  {
    path: 'b2b/interview/:id',
    component: CompanyVirtualInterviewComponent,
  },
  {
    path: 'start-interview-session/:id',
    component: StartSessionComponent,
  },
  {
    path: 'virtual-interview/:id/start',
    component: StartInterviewComponent,
  },
  {
    path: 'virtual-interview-company',
    component: VrMainComponent,
  },

  {
    path: 'job-description/:id',
    component: JopDescriptionComponent,
  },
  {
    path: 'apply-job/:id',
    component: ApplyLayoutComponent,
  },
  {
    path: 'job-list',
    component: UesrJobListComponent,
  },
  {
    path: 'user-profile',
    component: UserProfileComponent,
  },
  { path: 'company-admin/virtual-interviews', component: VirtualBillingComingSoonComponent, canActivate: [AuthGuard] },
  { path: 'company-admin/billing-payments',   component: VirtualBillingComingSoonComponent, canActivate: [AuthGuard] },
  {
    path: 'company-admin',
    component: CompanyAdminSidebarComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'company-profile', component: CompanyProfileAdminComponent },
      // { path: 'positions',         component: PositionsComponent },
      { path: 'job-posts', component: JobVacancyComponent },
      { path: 'comapny-reviews', component: CompanyReviewsComponent },
      // { path: 'job-applications',  component: JobApplicationsComponent },
      { path: 'add-job', component: AddJobComponent },
      { path: 'edit-job/:id', component: AddJobComponent },
      { path: 'all-applications', component: AllApplicationsComponent },
      { path: 'application/:id', component: AppDetailsComponent },
      { path: 'positions', component: PositionTableComponent },
      { path: 'edit-position/:id', component: PositionFormComponent },
      { path: 'add-position', component: PositionFormComponent },
      { path: 'interview-setup', component: InterviewSetupComponent },
      { path: 'interview-results/:id', component: InterviewResultsComponent },
      { path: 'interview-result/:id', component: VrInterviewResultComponent },
      {
        path: 'billing-service-details',
        component: BillingServiceDetailsComponent,
      },
      {
        path: 'billing-job-posting-details',
        component: BillingJobPostingDetailsComponent,
      },
      {
        path: 'billing-talent-purchase',
        component: BillingTalentPurchaseComponent,
      },
      {
        path: 'billing-virtual-purchase',
        component: BillingVirtualPurchaseComponent,
      },
      { path: '', redirectTo: 'company-profile', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
